export default __webpack_public_path__ + "static/media/Filled Lobby.edf34e7c.svg";